import script from "./ProductsGrid.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductsGrid.vue?vue&type=script&setup=true&lang=ts"

import "./ProductsGrid.vue?vue&type=style&index=0&id=695adbe0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-695adbe0"]])

export default __exports__